import { render, staticRenderFns } from "./the-import-export.vue?vue&type=template&id=6a585546"
import script from "./the-import-export.vue?vue&type=script&lang=js"
export * from "./the-import-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports